module.exports = __webpack_public_path__ + "static/media/SchoolCosSchoolReceive6.a7e8098e.png";